import img1 from "./0603497816415.jpg";
import img2 from "./0603497818563.jpg";
import img3 from "./0603497818570.jpg";
import img4 from "./0603497818587.jpg";
import img5 from "./0603497818594.jpg";
import img6 from "./5021732510549.jpg";
import img5021732579386 from "./50217325793.jpg";
import img7 from "./50217326320.jpg";
import img8 from "./5021732587275.jpg";
import img9 from "./5021732580511pol.jpg";
import wa4 from "./wa4.jpg";

const covers = [
  {
    artist: "Johnny Hallyday",
    title: "Autoportrait",
    format: "45t Splatter",
    description:
      'Le 3 décembre 2011, la légende du rock s\'élève au premier étage de la Tour Eiffel pour offrir un concert exceptionnel et intimiste à un cercle restreint de privilégiés. Accompagné de ses fidèles musiciens, Johnny Hallyday livre une performance électrisante et chargée d\'émotions. Il dévoile pour la première fois son titre "Autoportrait", une œuvre rock écrite par Maurice Lindet et composée par John Mamann. "Autoportrait" sort en 45 tours vinyle splatter - édition limitée de 1 000 exemplaires - à l\'occasion du Disquaire Day le 12 avril 2025.',
    ref: [wa4],
  },
  {
    ref: [img7],
    artist: "Club Celest",
    title: "Ville Fantome",
    format: "Vinyle",
    description:
      "Une pop sensuelle et groovy épousant une voix saisissante. Nouvel EP alliant l'électro-pop, le R&B, la chanson française. On pense à Enchantée Julia, Ehla ou encore Brö, allant jusqu'à quelques touches de l'incontournable Bonnie Banane, influence dont Club Célest ne saurait se cacher.",
  },
  {
    ref: [img8],
    artist: "Etienne Daho",
    title: "Week-end à Rome Remixed",
    format: "MX45T - Blue Vinyl",
    description:
      'Célébrons le 40ème anniversaire de l\'emblématique "Weekend à Rome" avec ce vinyle bleu en édition limitée. Yuksek , Faux Real, The Ninety2 & Dimitri from Paris se sont emparés de ce hit pour lui rendre hommage en composant de nouveaux remixes. Photo de couverture inédite par Pierre & Gilles, clin d\'oeil à la pochette originale de l\'album "La notte, la notte" dont est issu le single.',
  },
  {
    ref: [img9],
    artist: "Michel Polnareff",
    title: "Sexcetera",
    format: "",
    description:
      "MICHEL POLNAREFF [est] de retour ! Dans son prochain album inédit, l'icône pop délivre un véritable chef d'œuvre en 8 titres pour la postérité. Enregistré entre la Californie, la France, Londres et l’Ecosse, ses nouvelles compositions ont une grâce devenue trop rare en ce début de millénaire. Premier inédit depuis plus de six ans, «Sexcetera» sera disponible en exclusivité chez les disquaires indépendants, en édition limitée maxi vinyle rouge.",
  },
];

export default covers;
